var App = App || {};

App.ResponsiveTables = (function ($) {
    "use strict";

    function init() {
        $(document).ready(function () {
            $("table.table").each(function () {
                if (!$(this).parent().hasClass("table-responsive")) {
                    $(this).wrap("<div class='table-responsive'></div>");
                }
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ResponsiveTables.init();
});